import React from 'react';
import { useOutletContext } from 'react-router-dom';

const Pricing = () => {
  const { openQuote } = useOutletContext();

  return (
    <section className="op-section" id="pricing">
      <div className="op-container">
        <div className="op-section-head">
          <span className="op-kicker">Pricing</span>
          <h1>Priced per practice, by quotation</h1>
          <p>
            Every anaesthetic practice is different — the number of doctors, the hospitals you work
            at and the modules you need all shape the fit. Rather than a one-size-fits-all price, we
            put together a tailored quotation for your practice.
          </p>
        </div>

        <div className="op-grid-3" style={{ marginBottom: 40 }}>
          <div className="op-card">
            <div className="op-card-icon">👥</div>
            <h3>Scales with your team</h3>
            <p>Solo anaesthetist or a large group — pricing is matched to the size and shape of your practice.</p>
          </div>
          <div className="op-card">
            <div className="op-card-icon">🧩</div>
            <h3>Pay for what you use</h3>
            <p>Activate the modules that fit your workflow, from pre-op assessments to claims and collections.</p>
          </div>
          <div className="op-card">
            <div className="op-card-icon">🤝</div>
            <h3>Hands-on onboarding</h3>
            <p>We help you set up codes, tariffs and integrations so you’re productive from day one.</p>
          </div>
        </div>

        <div className="op-price-band">
          <span className="op-price-tag">Custom Quotation</span>
          <h2 className="op-grad-text">Let’s build a proposal around your practice</h2>
          <p>Tell us a little about your setup and we’ll send you a tailored quotation — no obligation.</p>
          <button type="button" className="op-btn op-btn-primary op-btn-lg" onClick={openQuote}>
            Request a Quote
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
